import * as React from "react";
import { useTranslate } from "react-admin";
import {
  DateInput,
  DeleteButton,
  Edit,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  useNotify,
  useRecordContext,
} from "react-admin";
import { onMutateError } from "../utils/on-error";
import { isAdmin, isUser } from "../utils/token-data";

const SickLeaveTitle = ({ record }) => {
  return (
    <span>
      Sick Leave {record ? `"${record.dateFrom} - ${record.dateTo}"` : ""}
    </span>
  );
};

const SickLeaveEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <SickLeaveDeleteButton />
  </Toolbar>
);

const SickLeaveDeleteButton = () => {
  const record = useRecordContext();
  if (!isAdmin() && record.approvalStatus !== "pending") return null;
  return (
    <DeleteButton
      style={{
        marginLeft: "auto",
        marginRight: 0,
      }}
    />
  );
};

const validateDates = (values) => {
  const errors = {};

  if (new Date(values.dateFrom) > new Date(values.dateTo)) {
    errors.firstName = 'Błędne daty';
  }

  return errors
};

const SickLeaveEdit = (props) => {
  const notify = useNotify();
  const translate = useTranslate();

  return (
    <Edit
      title={<SickLeaveTitle />}
      mutationMode="pessimistic"
      mutationOptions={{ onError: (error) => onMutateError(error, notify) }}
      {...props}
    >
      <SimpleForm validate={validateDates} toolbar={<SickLeaveEditToolbar />}>
        <DateInput source="dateFrom" disabled label={translate("dateFrom")} />
        <DateInput source="dateTo" disabled label={translate("dateTo")} />
        <SelectInput
          source="approvalStatus"
          choices={[
            { id: "approved", name: translate('approvalStatus.approved') },
            { id: "pending", name: translate('approvalStatus.pending') },
            { id: "rejected", name: translate('approvalStatus.rejected') },
          ]}
          disabled={isUser()}
          validate={required()}
          label={translate("sickLeave.approvalStatus")}
        />
        <TextInput
          source="notes"
          multiline
          fullWidth
          label={translate("sickLeave.notes")}
        />
      </SimpleForm>
    </Edit>
  );
};

export default SickLeaveEdit;
